import Vue from 'vue';
import Vuex from 'vuex';
import all from './actions';
import getters from './getters';

Vue.use(Vuex);

// 应用初始状态
const state = {
  userInfo: { role: '', name: '', username: '' },
};
// 创建 store 实例
export default new Vuex.Store({
  ...all,
  getters,
  state,
});



// WEBPACK FOOTER //
// ./src/vuex/store.js